<template>
	<div>
		<p>{{ companyinfo }}</p>
	</div>
</template>
<script>
export default {
	data() {
		return {
			companyinfo: ""
		}
	},
	methods: {
		getCustomerinfoList() {
			const vs = this.$vs;
			this.$store.dispatch("customer/listCustomerInfo").then(response => {
				if (response.success == true) {
					this.customerInfoList = this.$store.state.customer.CustomerInfoList;
					let findCustomerId = this.customerInfoList.filter(post => {
						return post.CompanyInfoId.includes(this.params.data.CompanyInfoId);
					});
					this.companyinfo = findCustomerId[0].Name
				} else
					console.log(response.statusText)

			});
		},
	},
	created() {
		this.getCustomerinfoList();
	}
}
</script>